<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text> </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="passModal" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>پاس کردن چک</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <h5>
              آیا از پاس کردن چک به مبلغ
              {{ Number(selected.amount).toLocaleString() }} ریال اطمینان دارید؟
            </h5>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="passModal = false">
            خیر
          </v-btn>
          <v-btn color="primary" :loading="isBusy2" @click="doPassCheque()">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="returnModal" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>برگشت زدن چک</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <h5>
              آیا از برگشت زدن چک به مبلغ
              {{ Number(selected.amount).toLocaleString() }} ریال اطمینان دارید؟
            </h5>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="returnModal = false">
            خیر
          </v-btn>
          <v-btn color="primary" :loading="isBusy2" @click="doReturn()">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newChequeDialog" max-width="600px">
      <v-card style="overflow-y: scroll" height="80vh">
        <v-card-title>
          <h4>ثبت چک جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-row>
              <v-col cols="6" class="pb-0">
                <v-autocomplete
                  @change="getBalance(newPayment.shopCustomerId)"
                  auto-select-first
                  no-data-text="نتیجه‌ای یافت نشد!"
                  v-model="newPayment.shopCustomerId"
                  :items="customers"
                  item-text="name"
                  item-value="id"
                  class="p-0"
                  label="نام مشتری"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col class="text-right" cols="6">
                <v-btn
                  color="primary"
                  style="float: right"
                  @click="openAddCustomer()"
                  v-shortkey.once="['n']"
                  @shortkey="openAddCustomer()"
                >
                  ثبت مشتری جدید +
                </v-btn></v-col
              >
            </v-row>
            <p v-if="newPayment.shopCustomerId">
              مانده حساب مشتری:
              <span v-if="newPayment.customerBalance">{{
                newPayment.customerBalance
              }}</span>
              <b-spinner v-else></b-spinner>
            </p>
            <v-text-field
              outlined
              dense
              type="number"
              label="مبلغ پرداخت"
              :loading="progress"
              v-model="newPayment.totalCost"
            ></v-text-field>
            <p>
              {{
                newPayment.totalCost
                  ? Number(newPayment.totalCost).toLocaleString() + "ریال"
                  : ""
              }}
            </p>
            <br />
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  label="* شماره چک"
                  v-model="check.number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col class="py-0">
                <v-text-field
                  label="* نام بانک"
                  v-model="check.bankName"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  label="شماره صیاد"
                  v-model="check.chequeSayyad"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <label>* تاریخ چک</label>
                <date-picker
                  v-model="check.date"
                  :editable="true"
                ></date-picker>
              </v-col>
              <v-col class="pt-0" cols="12">
                <v-textarea
                  outlined
                  dense
                  label="توضیحات"
                  rows="3"
                  v-model="newPayment.description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newChequeDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" :loading="isBusy2" @click="addCheque()">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newCustomerDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ثبت مشتری جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="نام مشتری"
              :loading="isBusy2"
              v-model="newCustomer.name"
            ></v-text-field>
            <v-select
              label="نوع مشتری"
              :items="customerTypes"
              v-model="newCustomer.type"
              :loading="isBusy2"
              outlined
              dense
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newCustomerDialog = false"
          >
            لغو
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!newCustomer.name"
            :loading="isBusy2"
            @click="addCustomer()"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <loading v-if="vLoading" />

    <v-col lg="12" class="ml-auto"></v-col>
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <v-row>
          <v-col>
            <h5 class="m-0 pt-1">مدیریت چک‌ها</h5>
          </v-col>
          <v-col>
            <v-btn style="float: left" @click="shopNewChequeDialog()">
              ثبت جدید +
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row class="p-0">
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ شروع"
                v-model="startDate"
                :editable="true"
              ></date-picker
            ></v-col>
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ پایان"
                v-model="endDate"
                :editable="true"
              ></date-picker
            ></v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                auto-select-first
                class="v-select"
                clearable
                no-data-text="نتیجه‌ای یافت نشد!"
                v-model="theCustomer"
                :items="customers"
                item-text="name"
                item-value="id"
                label="نام مشتری"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-select
                outlined
                dense
                clearable
                :items="chequeStatuses"
                v-model="chequeStatus"
                class="v-select"
                label="وضعیت چک"
              >
              </v-select>
            </v-col>
            <v-col>
              <b-btn class="btn btn-dark" @click="getCheques()">جستجو</b-btn>
            </v-col>
          </v-row>
        </template>
        <v-row class="p-0">
          <v-col cols="12" class="pb-0 mt-3">
            <v-text-field
              v-model="userInput"
              placeholder="جستجو"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <b-table
          responsive
          show-empty
          :items="cheques"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="userInput"
          id="payments-table"
          @filtered="onFiltered"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(shopCustomerName)="data">
            <div style="text-align: center; vertical-align: middle">
              <router-link :to="'/shop/customer/' + data.item.shopCustomerId"
                >{{ data.value }} ({{
                  data.item.shopCustomerCode
                }})</router-link
              >
            </div>
          </template>
          <template v-slot:cell(description)="data">
            <div style="text-align: center; vertical-align: middle">
              {{
                data.value.length > 100
                  ? data.value.slice(0, 100) + "..."
                  : data.value
              }}
            </div>
          </template>
          <template v-slot:cell(amount)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }} ریال
            </div>
          </template>
          <template v-slot:cell(operation)="row">
            <div style="text-align: center; vertical-align: middle">
              <div v-if="row.item.chequeStatus == 'ثبت شده'">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </div>
              <div v-else>
                <b-btn
                  variant="primary"
                  class="mr-1 mt-1"
                  @click="print(row.item)"
                  >چاپ رسید</b-btn
                >
              </div>
            </div>
          </template>
          <template #row-details="row">
            <div
              class="animated fadeIn"
              style="text-align: center; vertical-align: middle"
            >
              <b-btn
                variant="primary"
                class="mr-1 mt-1"
                @click="print(row.item)"
                >چاپ رسید</b-btn
              >
              <b-btn
                variant="success"
                class="mr-1 mt-1"
                @click="openPassModal(row.item)"
                >پاس کردن</b-btn
              >
              <b-btn
                variant="danger"
                class="mr-1 mt-1"
                @click="openReturnModal(row.item)"
                >برگشت زدن</b-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="TotalRows"
          :per-page="perPage"
          aria-controls="payments-table"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
      <br />
    </b-card>
    <!-- receipt -->
    <v-card>
      <div id="Receipt" v-show="false">
        <table class="mainTable m-3 p-4 h-100 w-100">
          <thead>
            <tr>
              <td>
                <div style="text-align: center; width: 100%">
                  <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content" style="padding: 5px 15px">
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 0 10px;
                      margin: 10px 0;
                    "
                  >
                    <div style="text-align: center">
                      <span style="font-size: 20px">رسید چک</span>
                    </div>
                    <br />
                    <div style="direction: rtl">
                      <table style="border: 0px solid black !important">
                        <tr>
                          <td style="border: 0px solid black !important">
                            نام مشتری:
                            <span style="font-size = 16px">{{
                              newPayment.shopCustomerId
                                ? customers.filter(
                                    (x) => x.id == newPayment.shopCustomerId
                                  )[0].name
                                : "-"
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            تاریخ:
                            {{ moment(new Date()).format("jYYYY/jMM/jDD") }}
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            کد مشتری:
                            <span style="font-size = 16px">{{
                              newPayment.shopCustomerId
                                ? customers.filter(
                                    (x) => x.id == newPayment.shopCustomerId
                                  )[0].customerCode
                                : "-"
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            ساعت: {{ moment(new Date()).format("HH:mm") }}
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            نوع مشتری:
                            <span style="font-size = 16px">{{
                              newPayment.shopCustomerId
                                ? customers.filter(
                                    (x) => x.id == newPayment.shopCustomerId
                                  )[0].type
                                : "-"
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          ></td>
                        </tr>
                      </table>

                      <br />
                    </div>
                  </div>
                  <div style="padding: 0 10px">
                    <table style="border: 0px solid black !important">
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>{{ "شیوه پرداخت: چک" }}</span>
                        </td>
                        <td style="border: 0px solid black !important">
                          <span>{{ "شماره چک: " + check.number }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>{{ "نام بانک: " + check.bankName }}</span>
                        </td>
                        <td style="border: 0px solid black !important">
                          <span>{{ "تاریخ چک: " + check.date }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>{{
                            "شماره صیاد: " +
                            (check.chequeSayyad ? check.chequeSayyad : "-")
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>
                            {{
                              "مبلغ کل: " +
                              Number(newPayment.totalCost).toLocaleString() +
                              " ریال"
                            }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <br />
                  <div
                    style="
                      border: 1px solid grey;
                      border-radius: 10px;
                      min-height: 75px;
                      padding: 10px;
                      break-inside: avoid;
                    "
                    v-if="newPayment.description"
                  >
                    <span>توضیحات: {{ newPayment.description }}</span>
                  </div>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
    <v-card>
      <div id="oldReceipt" v-show="false">
        <table class="mainTable m-3 p-4 h-100 w-100">
          <thead>
            <tr>
              <td>
                <div style="text-align: center; width: 100%">
                  <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content" style="padding: 5px 15px">
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 0 10px;
                      min-height: 120px;
                      margin: 10px 0;
                    "
                  >
                    <div style="text-align: center">
                      <span style="font-size: 19px">رسید چک(چاپ مجدد)</span>
                    </div>
                    <br />
                    <div style="direction: rtl">
                      <table style="border: 0px solid black !important">
                        <tr>
                          <td style="border: 0px solid black !important">
                            نام مشتری:
                            <span style="font-size = 16px">{{
                              printPayment.shopCustomerName
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            تاریخ:
                            {{ moment(new Date()).format("jYYYY/jMM/jDD") }}
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            کد مشتری:
                            <span style="font-size = 16px">{{
                              printPayment.shopCustomerCode
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            ساعت: {{ moment(new Date()).format("HH:mm") }}
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            نوع مشتری:
                            <span style="font-size = 16px">{{
                              printPayment.shopCustomerType
                            }}</span>
                          </td>
                        </tr>
                      </table>

                      <br />
                    </div>
                  </div>
                  <div style="padding: 0 10px">
                    <table style="border: 0px solid black !important">
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>{{ "شیوه پرداخت: " + printPayment.type }}</span>
                        </td>
                        <td
                          v-if="printPayment.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>{{
                            "شماره چک: " + printPayment.chequeNo
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          v-if="printPayment.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>{{
                            "نام بانک: " + printPayment.chequeBank
                          }}</span>
                        </td>
                        <td
                          v-if="printPayment.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>{{
                            "تاریخ چک: " + printPayment.chequeDate
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          v-if="printPayment.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>
                            {{
                              "شماره صیاد: " +
                              (printPayment.chequeSayyad
                                ? printPayment.chequeSayyad
                                : "-")
                            }}
                          </span>
                        </td>
                        <td
                          v-if="printPayment.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          {{ "وضعیت چک: " + printPayment.chequeStatus }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>
                            {{ "مبلغ: " + printPayment.amount + " ریال" }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <br />
                  <div
                    style="
                      border: 1px solid grey;
                      border-radius: 10px;
                      min-height: 75px;
                      padding: 10px;
                      break-inside: avoid;
                    "
                  >
                    <span>توضیحات: {{ printPayment.description }}</span>
                  </div>
                  <br />
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
    <!-- receipt -->

    <br />

    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },

  data() {
    return {
      guide: false,

      moment: moment,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).add(7, "d").format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "date", label: "تاریخ سررسید" },
        { key: "chequeBank", label: "نام بانک" },
        { key: "chequeNo", label: "شماره چک" },
        { key: "amount", label: "مبلغ" },
        { key: "description", label: "توضیحات" },
        { key: "chequeStatus", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      chequeStatuses: [
        { value: "submitted", text: "ثبت شده" },
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
      ],
      chequeStatus: "",
      theCustomer: "",
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      TotalRows: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      filter: null,
      gettingReceipt: false,
      cheques: [],
      selected: "",
      newPaymentDialog: false,
      newPayment: {
        customerBalance: "",
        totalCost: 0,
        description: "",
      },
      progress: false,
      customer: {},
      customerOldBalance: 0,
      customerNewBalance: 0,
      printPayment: {},
      printPaymentIncome: {},
      passModal: false,
      returnModal: false,
      passCheque: false,
      isBusy2: false,
      newChequeDialog: false,
      check: {},
      customers: [],
      newCustomerDialog: false,
      newCustomer: {},
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      receiptNumber: "",
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    delFilter() {
      this.userInput = "";
    },
    openPassModal(item) {
      this.selected = item;
      this.passModal = true;
    },
    openReturnModal(item) {
      this.selected = item;
      this.returnModal = true;
    },
    shopNewChequeDialog() {
      this.newPayment = {
        customerBalance: "",
        totalCost: 0,
        description: "",
      };
      this.check = {};
      this.newChequeDialog = true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/getInfo",
        {
          shopIncomeId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printPayment = res.data;
            this.printPaymentIncome = res.data.income;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt("old");
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    addCustomer() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/new",
        {
          name: this.newCustomer.name,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.getCustomers();
            this.tempCustomer = res.data.id;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy2 = false;
        });
    },
    getCustomers() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customers = res.data;
            if (this.tempCustomer) {
              this.newPayment.shopCustomerId = this.tempCustomer;
              this.getBalance(this.tempCustomer);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    doPassCheque() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/passCheque",
        {
          shopIncomeId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.getCheques();
            this.passModal = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy2 = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    doReturn() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/returnCheque",
        {
          shopIncomeId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.getCheques();
            this.returnModal = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy2 = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getBalance(customerId) {
      this.newPayment.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.newPayment.customerBalance = Number(
              res.data.balance.split(",").join("")
            );
            if (this.newPayment.customerBalance > 0) {
              this.newPayment.customerBalance =
                this.newPayment.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.newPayment.customerBalance < 0) {
              this.newPayment.customerBalance =
                Math.abs(this.newPayment.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.newPayment.customerBalance = "تسویه";
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addCheque() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/new",
        {
          shopCustomerId: this.newPayment.shopCustomerId,
          totalCost: this.newPayment.totalCost,
          paymentType: "cheque",
          chequeNo: this.check.number ? this.check.number : "",
          chequeSayyad: this.check.chequeSayyad ? this.check.chequeSayyad : "",
          chequeDate: this.check.date ? this.check.date : "",
          chequeBank: this.check.bankName ? this.check.bankName : "",
          description: this.newPayment.description
            ? this.newPayment.description
            : "",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newChequeDialog = false;
            setTimeout(() => {
              this.printReceipt("new");
            }, 500);
            this.getCheques();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.isBusy2 = false;
        });
    },
    openAddCustomer() {
      this.newCustomer = {};
      this.newCustomerDialog = true;
    },
    printReceipt(status) {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display:table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      if (status == "new") {
        myWindow.document.write(document.getElementById("Receipt").innerHTML);
      } else {
        myWindow.document.write(
          document.getElementById("oldReceipt").innerHTML
        );
      }

      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    editCustomer() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/edit",
        {
          shopCustomerId: this.selected,
          name: this.customer.name,
          mobile: this.customer.mobile,
          email: this.customer.email,
          economicCode: this.customer.economicCode,
          phone: this.customer.phone,
          address: this.customer.address,
          natCode: this.customer.natCode,
          type: this.customer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.customerDialog = false;
            this.isBusy = true;
            this.customerName = "";
            this.customerPriority = "";
            this.customerEmail = "";
            this.customerMobile = "";
            this.getCheques();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        {
          shopCustomerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          console.log(res.data.name);
          if (res.status == 200) {
            this.customer.name = res.data.name;
            this.customer.mobile = res.data.mobile;
            this.customer.email = res.data.email;
            this.customer.economicCode = res.data.economicCode;
            this.customer.phone = res.data.phone;
            this.customer.address = res.data.address;
            this.customer.natCode = res.data.natCode;
            this.customer.type = res.data.type;
            this.customer.balance = res.data.balance;
            this.progress = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getCheques() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/cheques",
        {
          shopCustomerId: this.theCustomer,
          chequeStatus: this.chequeStatus,
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          this.isBusy = false;
          if (res.status == 200) {
            this.cheques = res.data;
            this.TotalRows = this.cheques.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
          this.vLoading = false;
        });
    },
    getCustomers() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getCheques();
    this.getCustomers();
  },
};
</script>
<style lang="scss">
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
